import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { SpendCategoryGlCodeDto } from 'entities/ReportSpendSummary';

interface CategoryGlCodesTooltipProps {
    codes: SpendCategoryGlCodeDto[];
}

export const CategoryGlCodesTooltip = ({
    codes,
}: CategoryGlCodesTooltipProps) => {
    const { t } = useTranslation();

    return (
        <Box sx={{ width: '215px', padding: '4px' }}>
            <Typography
                variant="subtitle2"
                sx={{ color: 'rgba(0, 0, 0, 0.50)', marginBottom: '18px' }}
            >
                {t('spendSummary.glCodes')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {codes.map((code) => (
                    <Box
                        key={`${code.propertyId}-${code.glCode}`}
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'space-between',
                            gap: '12px',
                        }}
                    >
                        <Typography variant="body2" sx={{ minWidth: 0 }}>
                            {code.propertyName}
                        </Typography>
                        <Typography
                            variant="subtitle2"
                            sx={{ flexShrink: 0, marginLeft: 'auto' }}
                        >
                            {code.glCode}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
